export const LISTED_BY_OPTIONS = [
  { value: 'Individual', key: 'individual' },
  { value: 'Dealer', key: 'dealer' },
  { value: 'Business / Company', key: 'business' },
];

export const AD_TYPE_OPTIONS = [
  { value: 'for_sale', key: 'forSale', label: 'For Sale' },
  { value: 'for_rent', key: 'forRent', label: 'For Rent' },
  { value: 'wanted', key: 'wanted', label: 'Wanted' },
  { value: 'exchange', key: 'exchange', label: 'Exchange' },
  { value: 'free', key: 'free', label: 'Free' },
];

export const PRICE_TYPE_OPTIONS = [
  { value: 'fixed', key: 'fixed', label: 'Fixed price' },
  { value: 'negotiable', key: 'negotiable', label: 'Negotiable' },
  { value: 'free', key: 'free', label: 'Free' },
  { value: 'contact', key: 'contact', label: 'Contact for price' },
];

export const RETURN_POLICY_OPTIONS = [
  { value: 'no_returns', key: 'noReturns', label: 'No returns' },
  { value: '7_days', key: '7days', label: '7 days return' },
  { value: '15_days', key: '15days', label: '15 days return' },
  { value: '30_days', key: '30days', label: '30 days return' },
];

export const PAYMENT_METHODS = [
  { value: 'cash', key: 'cash', label: 'Cash', icon: '€' },
  { value: 'upi', key: 'upi', label: 'UPI', icon: null },
  { value: 'bank_transfer', key: 'bankTransfer', label: 'Bank Transfer', icon: null },
  { value: 'emi', key: 'emi', label: 'EMI', icon: null },
];

export const CONTACT_PREFERENCE_OPTIONS = [
  { value: 'chat', key: 'chat', label: 'Chat only' },
  { value: 'phone', key: 'phone', label: 'Phone only' },
  { value: 'both', key: 'both', label: 'Chat & Phone' },
];

export const COURIER_OPTIONS = [
  'speedy',
  'econt',
  'dhl',
  'fedex',
  'eps',
  'rapido',
  'other',
];
